module.exports = __webpack_public_path__ + "static/media/matriz.41e67155.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/matriz.svg
// module id = 184
// module chunks = 0